// extracted by mini-css-extract-plugin
module.exports = {"base":"index_base__3SJy3","page-submit":"index_page-submit__3nJlA","page-list":"index_page-list__2Q1CC","buttons":"index_buttons__AvpyT"};